import { FeasibilityExclusions } from '../models';

export const EMPTY_FEASIBILITY_EXCLUSIONS: FeasibilityExclusions = {
  enabled: false,
  start: '',
  end: '',
  criteria: [],
  criteriaSurveys: [],
  statuses: [],
};
